module.exports = __webpack_public_path__ + "img/Close-TH.92ad6195.png";